module.exports = __webpack_public_path__ + "img/tatuta-bento.5e3523db.png";